module.exports = __webpack_public_path__ + "static/img/prever.2174cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/prever.png
// module id = pIf7
// module chunks = 50